export enum DeliveryType {
  Email = 1,
  SMS = 2,
  EmailAndSMS = 3
}
